<!-- Backdrop -->
<div class="modal-backdrop fade show"></div>

<!-- Modal -->
<div class="modal d-block" tabindex="-1">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
      </div>

      <!-- Body -->
      <div class="modal-body text-center">
        <!-- Image Preview -->
        <img *ngIf="fileType === 'image'" [src]="url" class="img-fluid" />

        <!-- PDF Preview -->
        <iframe *ngIf="fileType === 'pdf'" [src]="safeUrl" width="100%" height="600px"></iframe>

        <!-- Office Document Preview -->
        <iframe *ngIf="fileType === 'office'" [src]="safeUrl" width="100%" height="600px"></iframe>

        <!-- Text Preview -->
        <iframe *ngIf="fileType === 'text'" [src]="safeUrl" width="100%" height="600px"></iframe>

        <!-- Unknown File Type -->
        <p *ngIf="fileType === 'unknown'" class="text-muted">
          Preview not available for this file type.
        </p>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button *ngIf="showDownload" class="btn btn-primary" (click)="downloadFile()">Download</button>
        <button *ngIf="showOpenNewTab" class="btn btn-secondary" (click)="openInNewTab()">Open in New Tab</button>
      </div>

    </div>
  </div>
</div>
